export default __webpack_public_path__ + "static/media/groovy-cfs.60ef6dbe.glb";